import {API_URL, apiPost} from '../api'

export const createLeaderboardBanner = async data => {
    return await apiPost(API_URL, 'admin/banner', data)
}
